import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { LoginPayload } from '../../models/loginPayload';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { ChangePasswordPayload } from '../../models/changePasswordPayload';
import { LoginResponse, UserData } from 'src/app/models/loginResponse';
import Swal from 'sweetalert2';
import { logoutResponse } from 'src/app/models/logoutResponse';
import { commonResponse } from 'src/app/models/commonResponse';
import { resetPayload } from 'src/app/models/resetPayload';
import { ForgotPayload } from 'src/app/models/forgotPayload';
import { TranslateService } from '@ngx-translate/core';
import { verifyOtpPayload } from 'src/app/models/verifyOtpPayload';
import { PhoneFormat } from 'src/app/models/PhoneFormat';
import { DocumentResponse } from 'src/app/models/DocumentResponse';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  emailSubject: BehaviorSubject<string | null> = new BehaviorSubject<
    string | null
  >('');
  profileDetails: BehaviorSubject<UserData | null> =
    new BehaviorSubject<UserData | null>(null);
  resetPhoneSubject: BehaviorSubject<PhoneFormat | null> =
    new BehaviorSubject<PhoneFormat | null>(null);
  resetToken: BehaviorSubject<string> = new BehaviorSubject<string>('');

  FCMtoken: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(
    null
  );

  docsData = {
    name: '',
    issueDate: '',
    issueDateRequire: false,
    expiryDate: '',
    expiryDateRequire: false,
    key: [
      {
        title: 'first image',
        image: '',
        required: false
      },
      {
        title: 'second image',
        image: '',
        required: false
      }
    ]
  };

  private isOpenSubject = new BehaviorSubject<boolean>(false);
  isOpen$ = this.isOpenSubject.asObservable();
  private drawerOpenSubject = new BehaviorSubject<boolean>(false);
  drawerOpen$ = this.drawerOpenSubject.asObservable();
  private drawerOpen = false;

  constructor(
    private readonly http: HttpClient,
    private _translate: TranslateService
  ) {
    this.drawerOpenSubject.next(false);
  }

  isAuthenticated(): boolean {
    if (
      localStorage.getItem(environment.storageKey) &&
      localStorage.getItem(environment.storageKey) !== null
    ) {
      return true;
    } else {
      return false;
    }
  }

  login(payload: LoginPayload): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(
      `${environment.base_url}/Factory/login`,
      payload
    );
  }

  getProfile(): Observable<UserData> {
    return this.http
      .get<{ data: UserData }>(`${environment.base_url}/Factory/getProfile`)
      .pipe(map(res => res.data));
  }

  verifyOtp(otp: verifyOtpPayload): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(
      `${environment.base_url}/Factory/verifyOtp`,
      otp
    );
  }

  forgotPassword(payload: ForgotPayload): Observable<commonResponse> {
    return this.http.post<commonResponse>(
      `${environment.base_url}/Factory/forgotPassword`,
      payload
    );
  }

  resetPassword(data: resetPayload): Observable<commonResponse> {
    return this.http.post<commonResponse>(
      `${environment.base_url}/Factory/resetPassword`,
      data
    );
  }

  changePassword(data: ChangePasswordPayload): Observable<commonResponse> {
    return this.http.post<commonResponse>(
      `${environment.base_url}/Factory/changePassword`,
      data
    );
  }

  // data not yet confirmed from backend will implement once it is done
  updateProfile(data: UserData): Observable<LoginResponse> {
    return this.http.put<LoginResponse>(
      `${environment.base_url}/Factory/updateProfile`,
      data
    );
  }

  logout(): Observable<logoutResponse> {
    return this.http.get<logoutResponse>(
      `${environment.base_url}/Factory/logout`
    );
  }
  getVendorDocsFromAdmin(): Observable<DocumentResponse> {
    return this.http.get<DocumentResponse>(
      `${environment.base_url}/factory/requiredDocument`
    );
  }

  toggle(): void {
    this.isOpenSubject.next(!this.isOpenSubject.value);
  }

  logoutAlert(): Promise<any> {
    return new Promise((resolve: any) => {
      Swal.fire({
        title: this._translate.instant('AreYouSure'),
        text: this._translate.instant('WillBeLoggedOut'),
        icon: this._translate.instant('warning'),
        showCancelButton: true,
        cancelButtonText: this._translate.instant('Cancel'),
        confirmButtonColor: '#F3E00B',
        cancelButtonColor: '#000',
        confirmButtonText: this._translate.instant('Logout')
      }).then((result: any) => {
        return resolve(result);
      });
    });
  }

  getDrawerOpen(): boolean {
    return this.drawerOpen;
  }

  toggleDrawer(): void {
    this.drawerOpen = !this.drawerOpen;
  }
}
